var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"fuzzy-search",attrs:{"placeholder":"Fuzzy Search","size":"mini","value":_vm.query,"prefix-icon":"el-icon-search"},on:{"input":function($event){return _vm.search($event)}}},[_c('i',{staticClass:"el-input__icon el-icon-circle-close is-clickable",attrs:{"slot":"suffix"},on:{"click":_vm.clear},slot:"suffix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de15d0a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FuzzySearch.vue
// module id = null
// module chunks = 